import styles from './App.module.scss';
import {Routes, Route, useLocation} from 'react-router-dom';
import Main from './pages/main/Main';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { login } from './module/redux/profile';
import axios from 'axios';
import Community from './pages/community/Community';
import Download from './pages/download/Download';
import Introduce from './pages/introduce/Introduce';
import Notice from './pages/notice/Notice';
import Service from './pages/service/Service';
import { useState } from 'react';

const App = () => {

  const location = useLocation();

  const [isLoginChecked, setLoginChecked] = useState(false);
  const dispatch = useDispatch();
  
  useEffect(()=>{
    autoLogin();
  }, []);

  useEffect(()=>{
    window.scrollTo(0, 0);
  }, [location]);
  
  const autoLogin = () => {
    axios.defaults.withCredentials=true;
    axios.get('/api/profile/checkLogin')
    .then((res) => {
      if (res.data.code === 220){
        dispatch(login(res.data.profile));
      }
      else{
        console.log("AUTO LOGIN FAILED!");
      }
    })
    .finally(()=>{
      setLoginChecked(true);
    });
  }

  if (!isLoginChecked){
    return '';
  }

  return (
    <div styles={styles.App}>
      <Routes>
        <Route path='/' element={<Main/>}/>

        <Route path='/login' element={<Login/>}/>
        <Route path='/register' element={<Register/>}/>

        <Route path='/introduce' element={<Introduce/>}/>
        <Route path='/notice' element={<Notice/>}/>
        <Route path='/download' element={<Download/>}/>
        <Route path='/community' element={<Community/>}/>
        <Route path='/service' element={<Service/>}/>
      </Routes>
    </div>
  );
}

export default App;
